module.exports = __webpack_public_path__ + "img/spotifyLogo.d154494c.png";